import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {questionBaseValidator} from './questionBase';

export const imageMarkupQuestionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.IMAGE_MARKUP),
});
